module.exports = __webpack_public_path__ + "img/Girl_010034.d5406af6.png";